module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/32Ax2B/tc-custom/9781468307870.jpg?1720281562526",
      "alt": "This image is the cover for the book Don't Point That Thing at Me, The Charlie Mortdecai Mystery Series"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Don't Point That Thing at Me, The Charlie Mortdecai Mystery Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("This witty crime thriller series debut follows the exploits of an unscrupulous art dealer with a stolen Goya—“this cult classic . . . is a true original” ("), _c('i', [_vm._v("Booklist")]), _vm._v(", starred review).")]), _c('br'), _c('br'), _vm._v("In "), _c('i', [_vm._v("Don't Point that Thing at Me")]), _vm._v(", British author and art dealer Kyril Bonifiglioli introduced the Honorable Charlie Mortdecai: degenerate aristocrat, amoral art dealer, seasoned epicurean, unwilling assassin, and general knave-about-Piccadilly. Since its publication in the 1970s, this dark humored crime thriller has earned its place as a beloved cult classic. "), _c('br'), _c('br'), _vm._v("With his thuggish manservant Jock, Mortdecai endures all manner of nastiness involving secret police, angry foreign governments, stolen paintings, and dead clients, all just to make a dishonest living—while decked out in the most stylish garb and drinking the most bizarre alcoholic cocktails. Don’t miss the brilliant mixture of comedy, crime, and suspense.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kyril Bonfiglioli\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Kyril Bonfiglioli (1928 – 1985) was an art dealer, accomplished fencer, a fair shot with most weapons, and a serial marrier of beautiful women. He claimed to be “abstemious in all things except drink, food, tobacco, and talking,” and “loved and respected by all who knew him slightly.”")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The Overlook Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0